import styled from "styled-components";

export const CommentButton = styled.button`
  min-width: unset;
  background-color: transparent;
  border: none;
  padding: 10px;
  height: auto;
`;

export const CloseButton = styled.button`
  background-color: transparent;
  border: none;
  padding: 10px;
  height: auto;
  position: absolute;
  right: 0;
  top: 0;
`;

export const CommentsTitle = styled.h2`
  font-size: 16px;
  font-family: Lato;
  line-height: 22px;
  margin: 0;
  color: #474747;
  border-bottom: 1px solid #767676;
  padding-bottom: 10px;
`;

export const GroupComments = styled.div`
  padding-top: 10px;
`;

export const CommentsTextTitle = styled.h2`
  font-size: 16px;
  line-height: 22px;
  font-family: Lato;
  font-weight: bold;
  margin: 10px 0 0 0;
  text-align: left;
  color: #474747;
  text-transform: initial;
`;

export const CommentText = styled.p`
  font-size: 16px;
  line-height: 22px;
  font-family: Lato;
  margin: 0 0 10px 0;
  text-align: left;
`;
